import React, { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { getMetadata } from 'pages/Cms/helper'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { WikiPagesIcon } from 'redesign/components/atoms/Icon'
import { getAudienceName } from 'redesign/shared/utils/get-audience-name/get-audience-name'
import routes from 'services/RoutesProvider/routes'
import ContentCard from '../content-card'
import type { WikiCardProps } from './types'

const WikiCard: React.FC<WikiCardProps> = ({ content }) => {
  const { t, language } = useFavurTranslation()
  const metadata = useMemo(() => getMetadata({ content, language }), [content, language])
  const audiences = useMemo(
    () => content?.audiences?.map((audience) => getAudienceName({ audience, language, t })).join(','),
    [content?.audiences, language, t],
  )

  if (!metadata) {
    return null
  }

  return (
    <ContentCard
      dataTestId="wiki-card"
      header={{
        icon: <FramedIcon icon={WikiPagesIcon} isFilled />,
        title: metadata?.title,
        overflowSingleLine: true,
        subtitle: audiences,
        subtitleOverflowSingleLine: true,
      }}
      url={`${routes.cmsContentView}/${content?.uuid}`}
    />
  )
}

export default WikiCard
